<div class="sku-detail-container">
  <!-- Sticky Header -->
  <div class="sticky-header" [class.scrolled]="isScrolled()">
    <div class="flex justify-between items-center mb-5">
      <div class="flex items-center gap-3">
        <h1 class="text-2xl font-semibold text-gray-800">
          {{ "sku_management.detail.title" | translate }}
        </h1>
      </div>
      <div class="flex items-center gap-2">
        <app-button
          [label]="'sku_management.detail.return' | translate"
          type="secondary"
          (emitOnClick)="onBack()"
          [outlined]="true"
        ></app-button>
      </div>
    </div>
  </div>

  <!-- Content -->
  <div class="sku-detail-content">
    @if (skuItem()) {
      @if (skuItem(); as item) {
        <div class="space-y-6">
          <!-- Basic Information Section -->
          <p-card styleClass="shadow-sm border-0">
            <ng-template pTemplate="header">
              <div class="flex items-center">
                <h2 class="text-lg font-medium text-gray-800">
                  {{
                    "sku_management.detail.sections.basic_information"
                      | translate
                  }}
                </h2>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.sku_name" | translate
                  }}</label>
                  <p class="text-gray-800">{{ item.skuName }}</p>
                </div>

                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.sku_code" | translate
                  }}</label>
                  <p class="text-gray-800">{{ item.skuCode }}</p>
                </div>

                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.product_name" | translate
                  }}</label>
                  <p class="text-gray-800">{{ item.spuName }}</p>
                </div>

                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.product_category" | translate
                  }}</label>
                  <p class="text-gray-800">{{ item.categoryName }}</p>
                </div>

                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.product_code" | translate
                  }}</label>
                  <p class="text-gray-800">{{ item.spuCode }}</p>
                </div>

                @if (item.setFlag !== 1) {
                  <div class="space-y-2">
                    <label class="text-sm font-medium text-gray-600">{{
                      "sku_management.detail.fields.product_brand" | translate
                    }}</label>
                    <p class="text-gray-800">
                      {{
                        item.brandName ||
                          ("sku_management.detail.values.na" | translate)
                      }}
                    </p>
                  </div>
                }
              </div>
            </ng-template>
          </p-card>

          <p-card styleClass="shadow-sm border-0">
            <ng-template pTemplate="header">
              <div class="flex items-center">
                <h2 class="text-lg font-medium text-gray-800">
                  {{ "goods.tax.section_title" | translate }}
                </h2>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">
                    {{ "sku_management.detail.fields.tax_category" | translate }}
                  </label>
                  <p class="text-gray-800">{{ getTaxDisplayValue(item) }}</p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">
                    {{ "sku_management.detail.fields.price_include_vat" | translate }}
                  </label>
                  <p class="text-gray-800">
                    {{ getVatDisplayKey(item) | translate }}
                  </p>
                </div>
              </div>
            </ng-template>
          </p-card>

          <!-- Vendors linked to this SKU (RBA-2122 / RBA-2150) -->
          <p-card styleClass="shadow-sm border-0">
            <ng-template pTemplate="header">
              <div class="flex items-center">
                <h2 class="text-lg font-medium text-gray-800">
                  {{
                    "sku_management.detail.sections.vendors" | translate
                  }}
                </h2>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              @if (item.vendorList && item.vendorList.length > 0) {
                <p-table
                  [value]="item.vendorList"
                  [tableStyle]="{ 'min-width': '100%' }"
                  styleClass="p-datatable-sm"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>
                        {{
                          "sku_management.detail.fields.vendor_code" | translate
                        }}
                      </th>
                      <th>
                        {{
                          "sku_management.detail.fields.vendor_name" | translate
                        }}
                      </th>
                      <th>
                        {{
                          "sku_management.detail.fields.vendor_sku_code"
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          "sku_management.detail.fields.vendor_email"
                            | translate
                        }}
                      </th>
                      <th>
                        {{
                          "sku_management.detail.fields.vendor_phone"
                            | translate
                        }}
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-vendor>
                    <tr>
                      <td>{{ vendor.vendorCode || "-" }}</td>
                      <td>{{ vendor.vendorName || "-" }}</td>
                      <td>{{ vendor.vendorSkuCode || "-" }}</td>
                      <td>{{ vendor.vendorEmail || "-" }}</td>
                      <td>{{ vendor.vendorPhone || "-" }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              } @else {
                <p class="text-gray-500 text-sm">
                  {{
                    "sku_management.detail.values.no_vendors" | translate
                  }}
                </p>
              }
            </ng-template>
          </p-card>

          @if (item.setFlag === 1) {
            <p-card styleClass="shadow-sm border-0">
              <ng-template pTemplate="header">
                <div class="flex items-center">
                  <h2 class="text-lg font-medium text-gray-800">
                    {{
                      "sku_management.create.package_components.title"
                        | translate
                    }}
                  </h2>
                </div>
              </ng-template>
              <ng-template pTemplate="content">
                <div class="overflow-x-auto">
                  <table class="w-full text-sm">
                    <thead>
                      <tr class="bg-gray-50 text-gray-600">
                        <th class="text-left p-3 font-medium">
                          {{
                            "sku_management.create.package_components.sku_code"
                              | translate
                          }}
                        </th>
                        <th class="text-left p-3 font-medium">
                          {{
                            "sku_management.create.package_components.sku_name"
                              | translate
                          }}
                        </th>
                        <th class="text-left p-3 font-medium">
                          {{
                            "sku_management.create.package_components.spu_code"
                              | translate
                          }}
                        </th>
                        <th class="text-left p-3 font-medium">
                          {{
                            "sku_management.create.package_components.spu_name"
                              | translate
                          }}
                        </th>
                        <th class="text-right p-3 font-medium">
                          {{
                            "sku_management.create.package_components.qty"
                              | translate
                          }}
                        </th>
                        <th class="text-right p-3 font-medium">
                          {{
                            "sku_management.create.package_components.sales_price"
                              | translate
                          }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (component of item.skuDetailList || []; track component.skuCode) {
                        <tr class="border-t border-gray-100">
                          <td class="p-3 font-mono">{{ component.skuCode }}</td>
                          <td class="p-3">{{ component.skuName }}</td>
                          <td class="p-3">{{ component.spuCode || "-" }}</td>
                          <td class="p-3">{{ component.spuName || "-" }}</td>
                          <td class="p-3 text-right">{{ component.num || 0 }}</td>
                          <td class="p-3 text-right">
                            {{
                              component.salesPrice
                                ? (component.salesPrice
                                  | currency: "" : "" : "1.0-0")
                                : "0"
                            }}
                            <span class="ml-1 text-gray-500 text-sm font-medium"
                              >đ</span
                            >
                          </td>
                        </tr>
                      } @empty {
                        <tr>
                          <td
                            colspan="6"
                            class="text-center text-gray-500 py-6"
                          >
                            {{
                              "sku_management.create.package_components.no_child_sku_selected"
                                | translate
                            }}
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </ng-template>
            </p-card>
          }

          <!-- SKU Attributes Section -->
          <p-card styleClass="shadow-sm border-0">
            <ng-template pTemplate="header">
              <div class="flex items-center">
                <h2 class="text-lg font-medium text-gray-800">
                  {{
                    "sku_management.detail.sections.sku_attributes" | translate
                  }}
                </h2>
                @if (item.setFlag !== 1) {
                  <span class="ml-2 text-xs text-red-500">{{
                    "sku_management.detail.attributes.participates_in_sku_generation"
                      | translate
                  }}</span>
                }
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="space-y-6">
                @if (
                  item.setFlag === 1 && packageSpuAttributes().length > 0
                ) {
                  <div class="bg-gray-50 rounded-lg p-4 shadow-sm">
                    <h3 class="text-lg font-semibold text-gray-800 mb-4">
                      {{
                        "sku_management.detail.attributes.product_attributes"
                          | translate
                      }}
                    </h3>
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                      @for (
                        attribute of packageSpuAttributes();
                        track attribute.name
                      ) {
                        <div class="space-y-2">
                          <label class="text-sm font-medium text-gray-600">
                            {{ attribute.name }}
                          </label>
                          <p class="text-gray-800">{{ attribute.value }}</p>
                        </div>
                      }
                    </div>
                  </div>
                }

                <!-- System Attributes (Static) -->
                <div class="bg-gray-50 rounded-lg p-4 shadow-sm">
                  <div class="flex items-center mb-4">
                    <h3 class="text-lg font-semibold text-gray-800">
                      {{
                        "sku_management.detail.attributes.system_attributes"
                          | translate
                      }}
                    </h3>
                  </div>
                  <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                    <div class="space-y-2">
                      <label class="text-sm font-medium text-gray-600">{{
                        "sku_management.detail.fields.product_weight"
                          | translate
                      }}</label>
                      <div class="flex items-center">
                        <span class="text-gray-800">
                          {{
                            item.weight
                              ? (item.weight | number: "1.0-0")
                              : ("sku_management.detail.values.zero"
                                | translate)
                          }}
                        </span>
                        <span class="ml-1 text-gray-500 text-sm font-medium"
                          >g</span
                        >
                      </div>
                    </div>

                    <div class="space-y-2">
                      <label class="text-sm font-medium text-gray-600">{{
                        "sku_management.detail.fields.product_length"
                          | translate
                      }}</label>
                      <div class="flex items-center">
                        <span class="text-gray-800">
                          {{
                            item.length
                              ? (item.length | number: "1.0-0")
                              : ("sku_management.detail.values.zero"
                                | translate)
                          }}
                        </span>
                        <span class="ml-1 text-gray-500 text-sm font-medium"
                          >cm</span
                        >
                      </div>
                    </div>

                    <div class="space-y-2">
                      <label class="text-sm font-medium text-gray-600">{{
                        "sku_management.detail.fields.product_width" | translate
                      }}</label>
                      <div class="flex items-center">
                        <span class="text-gray-800">
                          {{
                            item.width
                              ? (item.width | number: "1.0-0")
                              : ("sku_management.detail.values.zero"
                                | translate)
                          }}
                        </span>
                        <span class="ml-1 text-gray-500 text-sm font-medium"
                          >cm</span
                        >
                      </div>
                    </div>

                    <div class="space-y-2">
                      <label class="text-sm font-medium text-gray-600">{{
                        "sku_management.detail.fields.product_height"
                          | translate
                      }}</label>
                      <div class="flex items-center">
                        <span class="text-gray-800">
                          {{
                            item.height
                              ? (item.height | number: "1.0-0")
                              : ("sku_management.detail.values.zero"
                                | translate)
                          }}
                        </span>
                        <span class="ml-1 text-gray-500 text-sm font-medium"
                          >cm</span
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Dynamic Attributes -->
                @for (
                  attributeType of getDynamicAttributeTypes();
                  track attributeType
                ) {
                  @if (hasAttributesForType(attributeType)) {
                    <div class="bg-gray-50 rounded-lg p-4 shadow-sm">
                      <div class="flex items-center mb-4">
                        <h3 class="text-lg font-semibold text-gray-800">
                          {{
                            getAttributeSectionLabel(attributeType) | translate
                          }}
                        </h3>
                      </div>
                      <div class="grid grid-cols-2 md:grid-cols-4 gap-6">
                        @for (
                          attribute of getAttributesByType(attributeType);
                          track attribute.id
                        ) {
                          <div class="space-y-2">
                            <label class="text-sm font-medium text-gray-600">
                              @if (attribute.isSku) {
                                <span class="text-red-500 mr-1">#</span>
                              }
                              {{ attribute.attributeName }}
                            </label>
                            <p class="text-gray-800">
                              {{
                                attribute.attributeValue ||
                                  ("sku_management.detail.values.na"
                                    | translate)
                              }}
                            </p>
                          </div>
                        }
                      </div>
                    </div>
                  }
                }

                <!-- Barcode Section -->
                <div class="bg-white rounded-lg p-4 shadow-sm">
                  <h3 class="text-lg font-semibold text-gray-800 mb-4">
                    {{
                      "sku_management.detail.sections.identification_attributes"
                        | translate
                    }}
                  </h3>
                  @if (item.barcodes && item.barcodes.length > 0) {
                    <app-barcode-table
                      [barcodes]="item.barcodes"
                      [viewMode]="true"
                    />
                  } @else {
                    <p class="text-gray-500 text-sm">
                      {{
                        "sku_management.barcode.messages.no_barcodes"
                          | translate
                      }}
                    </p>
                  }
                </div>
              </div>
            </ng-template>
          </p-card>

          <!-- SKU Pricing Section -->
          <p-card styleClass="shadow-sm border-0">
            <ng-template pTemplate="header">
              <div class="flex items-center">
                <h2 class="text-lg font-medium text-gray-800">
                  {{ "sku_management.detail.sections.sku_pricing" | translate }}
                </h2>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <div class="grid grid-cols-2 md:grid-cols-3 gap-6">
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.cost_price" | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.costPrice
                        ? (item.costPrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.selling_price" | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.salesPrice
                        ? (item.salesPrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.market_price" | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.marketPrice
                        ? (item.marketPrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.distribution_price"
                      | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.distributionPrice
                        ? (item.distributionPrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.wholesale_price" | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.wholesalePrice
                        ? (item.wholesalePrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.clearance_price" | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.clearingPrice
                        ? (item.clearingPrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
                <div class="space-y-2">
                  <label class="text-sm font-medium text-gray-600">{{
                    "sku_management.detail.fields.promotion_price" | translate
                  }}</label>
                  <p class="text-gray-800">
                    {{
                      item.activityPrice
                        ? (item.activityPrice | currency: "" : "" : "1.0-0")
                        : ("sku_management.detail.values.zero" | translate)
                    }}
                    <span class="ml-1 text-gray-500 text-sm font-medium"
                      >đ</span
                    >
                  </p>
                </div>
              </div>
            </ng-template>
          </p-card>

          <!-- Sync History Section (RBA-2268) -->
          <p-card styleClass="shadow-sm border-0">
            <ng-template pTemplate="header">
              <div class="flex items-center">
                <h2 class="text-lg font-medium text-gray-800">
                  {{ "sku_management.detail.sections.sync_history" | translate }}
                </h2>
              </div>
            </ng-template>
            <ng-template pTemplate="content">
              <p-table
                [value]="syncHistory()"
                [loading]="syncHistoryLoading()"
                styleClass="p-datatable-sm"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>{{ "sync_report.table.columns.occurred_at" | translate }}</th>
                    <th>{{ "sync_report.table.columns.operation" | translate }}</th>
                    <th>{{ "sync_report.table.columns.trigger" | translate }}</th>
                    <th>{{ "sku_management.detail.sync_history.result" | translate }}</th>
                    <th>{{ "sync_report.table.columns.error_reason" | translate }}</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row>
                  <tr>
                    <td class="text-xs text-gray-600">
                      {{ formatDateTime(row.occurredAt) }}
                    </td>
                    <td>{{ row.operation }}</td>
                    <td>{{ row.trigger }}</td>
                    <td>
                      <p-tag
                        [value]="row.result"
                        [severity]="getSyncResultSeverity(row.result)"
                      />
                    </td>
                    <td class="text-sm text-red-600">
                      {{ row.errorReason || "-" }}
                    </td>
                  </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                  <tr>
                    <td colspan="5" class="text-center text-gray-500 italic">
                      {{ "sku_management.detail.sync_history.no_history" | translate }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </ng-template>
          </p-card>

          <!-- Product Images Section -->
          <!-- @if (hasImageData(item)) {
      <p-card styleClass="shadow-sm border-0">
        <ng-template pTemplate="header">
          <div class="flex items-center">
            <h2 class="text-lg font-medium text-gray-800">
              {{ "sku_management.detail.sections.product_images" | translate }}
            </h2>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="space-y-6"> -->
          <!-- Asset Name Row -->
          <!-- <div class="space-y-2">
              <label class="text-sm font-medium text-gray-600">{{
                "sku_management.detail.fields.material_name" | translate
              }}</label>
              <p class="text-gray-800">
                {{
                  item.materialName ||
                    ("sku_management.detail.values.na" | translate)
                }}
              </p>
            </div> -->

          <!-- Main Images Row -->
          <!-- @if (hasMainImages(item)) {
            <div class="space-y-3">
              <label class="text-sm font-medium text-gray-600">{{
                "sku_management.detail.fields.main_images" | translate
              }}</label>
              <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                @for (image of item.materialMainImages; track $index) { @if
                (image) {
                <div class="relative group">
                  <img
                    [src]="image"
                    [alt]="'Main image ' + ($index + 1)"
                    class="w-full h-24 object-cover rounded-lg border border-gray-200 hover:border-blue-300 transition-colors"
                    (error)="onImageError($event)"
                    loading="lazy"
                  />
                </div>
                } }
              </div>
            </div>
            } -->

          <!-- Detail Images Row -->
          <!-- @if (hasDetailImages(item)) {
            <div class="space-y-3">
              <label class="text-sm font-medium text-gray-600">{{
                "sku_management.detail.fields.detail_images" | translate
              }}</label>
              <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4">
                @for (image of item.imageList; track $index) {
                <div class="relative group">
                  @if (image) {
                  <img
                    [src]="image"
                    [alt]="'Detail image ' + ($index + 1)"
                    class="w-full h-24 object-cover rounded-lg border border-gray-200 hover:border-blue-300 transition-colors"
                    (error)="onImageError($event)"
                    loading="lazy"
                  />
                  }
                </div>
                }
              </div>
            </div>
            } -->
          <!-- </div>
        </ng-template>
      </p-card>
      } -->

          <!-- Status Section -->
          <!-- <p-card styleClass="shadow-sm border-0">
        <ng-template pTemplate="header">
          <div class="flex items-center">
            <h2 class="text-lg font-medium text-gray-800">
              {{
                "sku_management.detail.sections.approval_details" | translate
              }}
            </h2>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <div class="flex items-center gap-6 mb-4">
            <p class="text-sm font-medium text-gray-600">Status:</p>
            <p-tag
              [value]="getStatusDisplayText(item.status) | translate"
              [severity]="getStatusSeverity(item.status)"
              styleClass="status-tag"
              [ngStyle]="getStatusStyle(item.status)"
            />
          </div>

          <div class="flex items-center gap-6">
            <p class="text-sm font-medium text-gray-600">Comment:</p>
            <p class="text-gray-800">{{ item.auditIdea }}</p>
          </div>
        </ng-template>
      </p-card> -->
        </div>
      }
    }
  </div>
</div>
